import React, { useEffect, useState } from "react";
import { Modal, Spin } from "antd";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Skeleton from "@mui/material/Skeleton";

const HamperInfoModal = ({ open, onClose, selectedHamper, addHamper }) => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
    const userData = useSelector((state) => state?.login?.user?.result);
  
  const [hamperName, setHamperName] = useState(selectedHamper ? selectedHamper?.name : '');

  useEffect(() => {
    if (open && selectedHamper?.hamper_id) {
      fetchHamperProducts();
    }
  }, [open, selectedHamper]);

  const fetchHamperProducts = async () => {
   try {

      const payload = {
        user_id: userData?.user_id,
        company_id: userData?.company_id,
        hamper_id:selectedHamper?.hamper_id,
        limit: 100,
        offset: 0,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
      };

      const res = await axiosInstance.post(URLS.GET_HAMPERS_PRODUCTS, payload);
      const result = res?.data?.result?.[0];
      if (result?.status_code === 200) {
        const products = result?.product_list || [];
        setProducts(products);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error("Error fetching group products:", error);
      toast.error("حدث خطأ أثناء تحميل منتجات المجموعة");
    } finally {
      setLoading(false)
    }
  };
  

  return (
<Modal
  open={open}
  onCancel={onClose}
  footer={null}
  width={850}
  centered
  closable={true}
  title={
    <div className="text-2xl font-semibold mb-7">
      {hamperName || t("Hamper Details")}
    </div>
  }
>

  {loading ? (
   Array.from({ length: 4 }).map((_, index) => (
        <div
          key={index}
          className="flex px-4 py-3 border-b justify-between items-center"
        >
          <Skeleton height={50} width={300} />
          <Skeleton height={50} width={60} />
          <Skeleton height={50}  width={60}  />
        </div>
      ))
  ) : (
    <div className="flex flex-col">

      {/* TABLE HEADER */}
      <div className="grid grid-cols-3 bg-gray-100 rounded-md px-4 py-3 font-semibold text-gray-700 text-base">
        <div>{t("Products")}</div>
        <div className="text-center">{t("Sale Price")}</div>
        <div className="text-center">{t("Quantity")}</div>
      </div>

      {/* TABLE BODY */}
      <div className="max-h-[380px] overflow-y-auto mt-2 ">

        {products.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-3 px-4 py-3 border-b text-base items-center"
          >
            <div className="leading-5">
              {item.name}
            </div>

            <div className="text-center">
              {item.sale_price}
            </div>

            <div className="text-center">
              {item.qty_added}
            </div>
          </div>
        ))}

      </div>

      {/* TOTAL */}
      <div className="flex justify-end mt-4 text-base font-semibold">
        {t("Total")}:&nbsp;
        <span className="font-bold">
          EGP{" "}
          {products
            .reduce(
              (sum, p) => sum + p.sale_price * p.qty_added,
              0
            )
            .toFixed(2)}
        </span>
      </div>

      {/* ACTION BUTTON */}
      <button
      onClick={()=>{
        addHamper();
        onClose()
      }}
        className="mt-5 w-full bg-[#8BC34A] hover:bg-[#7CB342] text-white font-semibold py-3 rounded-lg text-lg"
      >
        {t("Add Hamper")}
      </button>

    </div>
  )}
</Modal>

  );
};

export default HamperInfoModal;
